import * as React from 'react';
import { withRouteData } from 'react-static';

import ConnectionPageComponent from '../../components/ConnectionPage/ConnectionPage';
import { ConnectionPageLocale } from '../../components/ConnectionPage/connectionPage.locale';

interface ConnectionPageProps {
  locale: ConnectionPageLocale;
}

const ConnectionPage: React.SFC<ConnectionPageProps> = ({ locale }) => (
  <ConnectionPageComponent locale={locale} />
);

export default withRouteData(ConnectionPage);



// WEBPACK FOOTER //
// /www/client/src/containers/ConnectionPage/ConnectionPage.tsx